











































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({})
export default class Drawer extends Vue {
  @Getter
  currentUser;
  mini = true;
  isOpened = false;
  items = [
    {
      icon: 'home',
      title: 'home',
      url: '/'
    }
    // {
    //   icon: 'schedule',
    //   title: 'schedule',
    //   url: 'schedule'
    // },
  ];

  settings = [
    {
      icon: 'settings',
      title: 'settings',
      url: '/settings'
    },
    {
      icon: 'feedback',
      title: 'feedback',
      url: '/feedback'
    }
  ];

  navigate(url) {
    if (url === '/') {
      if (this.currentUser.isEmployer) {
        this.$router.replace('employerHome');
      } else if (this.currentUser.isEmployee) {
        this.$router.replace('employeeHome');
      }
    }
  }

  viewProfile() {
    console.log('View Profile');
  }
}
